import { useContext } from 'react';
import { useEffectOnce } from '../../../hooks/useEffectOnce';
import { IMainFormQuestion } from '../types';
import { FormContext } from '../utils/formContext';
import { trackQuestionAnswerClick, trackQuestionShow } from '../utils/tracking';
import { useE2eLabelTracking } from './useE2eLabelTracking';

// Хук c хендлерами вопросов в главной форме. Добавляет к событиям трекинг
export const useMainFormQuestionHandlers = ({ containerType, answerYes, answerNo }: IMainFormQuestion) => {
  const formContext = useContext(FormContext);

  const onTrackQuestionShow = useE2eLabelTracking(trackQuestionShow);
  const onTrackQuestionAnswerClick = useE2eLabelTracking(trackQuestionAnswerClick);

  useEffectOnce(() => {
    onTrackQuestionShow({ questionName: containerType });
  });

  const onAnswerYes = () => {
    onTrackQuestionAnswerClick({
      questionName: containerType,
      answer: answerYes,
    });
    /* istanbul ignore next */
    formContext.onStepYes?.();
  };

  const onAnswerNo = () => {
    onTrackQuestionAnswerClick({
      questionName: containerType,
      answer: answerNo,
    });
    /* istanbul ignore next */
    formContext.onStepNo?.();
  };

  return { onAnswerYes, onAnswerNo };
};
